/**
 * Only same-origin paths may be navigated to from stored state. The value is
 * written before authentication, so treat it as untrusted: a protocol-relative
 * `//host` or an absolute URL would carry the user off Gripp entirely.
 */
export const isInternalPath = (path: string | null): boolean =>
  !!path &&
  path.startsWith('/') &&
  !path.startsWith('//') &&
  !path.includes('\\');
